import script from "./connecting.vue?vue&type=script&setup=true&lang=js"
export * from "./connecting.vue?vue&type=script&setup=true&lang=js"

import "./connecting.vue?vue&type=style&index=0&id=587703fe&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-587703fe"]])

export default __exports__